import { render, staticRenderFns } from "./is_first_confirm.vue?vue&type=template&id=bc18939c&scoped=true"
import script from "./is_first_confirm.vue?vue&type=script&lang=js"
export * from "./is_first_confirm.vue?vue&type=script&lang=js"
import style0 from "./is_first_confirm.vue?vue&type=style&index=0&id=bc18939c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc18939c",
  null
  
)

export default component.exports